import { toJalaali } from "jalaali-js";

// Persian month names
const PERSIAN_MONTHS = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

export type DateFormat = "numeric" | "text";

type formatPersianDateProps = {
  dateString: string;
  mode?: "all" | "onlyTime" | "onlyDate";
  format?: DateFormat;
};

export const formatPersianDate = ({
  dateString,
  mode = "all",
  format = "numeric",
}: formatPersianDateProps): string => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "تاریخ نامعتبر است";
  }

  const { jy, jm, jd } = toJalaali(date);
  const hour = date.getHours().toString().padStart(2, "0");
  const minute = date.getMinutes().toString().padStart(2, "0");
  const fullTime = ` ساعت ${hour}:${minute}`;

  const getDate = (): string => {
    if (format === "text") {
      // Format: "20 فروردین 1404"
      const monthName = PERSIAN_MONTHS[jm - 1];
      return `${jd} ${monthName} ${jy}`;
    } else {
      // Format: "1402/2/25"
      return `${jy}/${jm}/${jd}`;
    }
  };

  
  switch (mode) {
    case "onlyTime":
      return fullTime;
    case "onlyDate":
      return getDate();

    default:
      return getDate() + fullTime;
  }
};
